export const enClientPortalDashboardHistoryChart = {
    normalizedHistoryTooltip:
        'Relative shows the development as a like-for-like index. It only considers value changes of assets with values in multiple years during the selected period.',
}
